import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importMarketplaceLearnContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "MarketplaceLearnContainer" */
                '@perpay-web/fintech/components/containers/MarketplaceLearnContainer'
            ),
    );
